<ng-container>
    <div class="row header-row">
        <div class="col">
            <h5>{{"Serviço" | translate}} {{indice + 1}}</h5>
        </div>
    </div>
    <div class="row" id="description">
        <div class="col-12" [ngSwitch]="servico.CategoriaServico">
            <strong class="title">
                {{ servico.Titulo }}
                <span *ngSwitchCase="0">({{'REGULAR' | translate}})</span>
                <span *ngSwitchCase="1">({{'PRIVATIVO' | translate}})</span>
                <span *ngSwitchCase="2">({{'LUXO' | translate}})</span>
            </strong>
            <!-- ARRUMAR -->
            <strong class="subtitle" *ngIf="usuario.EmpresaId != null">({{ servico.Fornecedor}})</strong>
        </div>
        <div class="col">
            <div class="row">
                <div class="col" *ngIf="servico?.ExtraIntegracao2?.CategoriaServico">
                    <div class="flex">
                        <strong>{{'Categoria:' | translate}}</strong>
                        <p> {{servico?.ExtraIntegracao2?.CategoriaServico}} </p>
                    </div>
                </div>
                <div class="col">
                    <div class="flex">
                        <strong>{{"Pessoas" | translate }}:</strong>
                        <p>{{ servico.Adt + " " + ( servico.Adt > 1 ? "Adultos" : "Adulto")}}
                            {{servico.Chd > 0 ? "/ " + servico.Chd + " Criança(s)" : "" }}</p>
                    </div>
                </div>
                <div class="col">
                    <div class="flex">
                        <strong>{{"Data" | translate}}:</strong>
                        <p>{{ servico.Ate | date: 'dd/MM/yyyy' }}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="flex">
                        <strong>{{"Cidade" | translate}}:</strong>
                        <p>{{ servico.Cidade.Nome }}</p>
                    </div>
                </div>
                <div class="col" *ngIf="servico?.ExtraIntegracao2?.NomeFornecedor">
                    <div class="flex">
                        <strong>{{"Fornecedor" | translate}}:</strong>
                        <p> {{servico?.ExtraIntegracao2?.NomeFornecedor}} </p>
                    </div>
                    <!-- <div class="flex">
                          <strong>{{'CNPJ:' | translate}}</strong>
                          <p> {{servico?.ExtraIntegracao2?.NomeFornecedor}} </p>
                        </div> -->
                </div>
                <div class="col">
                    <div class="flex">
                        <!-- <strong>{{'Status:' | translate}}</strong>
                          <p>{{ servico.StatusDesc }}</p> -->
                        <div class="col flex" [ngSwitch]="servico.Status">
                            <h6>{{ "Status: " | translate}}</h6>
                            <span *ngSwitchCase="0" class="badge rounded-pill bg-secondary">Pendente</span>
                            <span *ngSwitchCase="1" class="badge rounded-pill bg-secondary">Aguardando</span>
                            <span *ngSwitchCase="2" class="badge rounded-pill bg-secondary">Reserva Parcial</span>
                            <span *ngSwitchCase="3" class="badge rounded-pill bg-success">Reservado</span>
                            <span *ngSwitchCase="4" class="badge rounded-pill bg-success">Solicitado</span>
                            <span *ngSwitchCase="5" class="badge rounded-pill bg-success">Emitido</span>
                            <span *ngSwitchCase="6" class="badge rounded-pill bg-success">Pago</span>
                            <span *ngSwitchCase="7" class="badge rounded-pill bg-warning text-dark">Problema
                                Técnico</span>
                            <span *ngSwitchCase="8" class="badge rounded-pill bg-warning text-dark">Cancelado</span>
                            <span *ngSwitchCase="9" class="badge rounded-pill bg-warning text-dark">Excluído</span>
                            <span *ngSwitchCase="10" class="badge rounded-pill bg-warning text-dark">Cancelamento com
                                Problema</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="flex">
                        <strong>{{'Prazo Cancelamento:' | translate}}</strong>
                        <p>{{ servico.PrazoCancelamento | date: "dd/MM/yyyy" }}</p>
                    </div>
                </div>
                <div class="col">
                    <div class="flex" *ngIf="empresaId != null && empresaId != undefined">
                        <strong>{{'Prazo Cancelamento Ws:' | translate}} </strong>
                        <p>{{ servico.PrazoCancelamentoWs | date: "dd/MM/yyyy" }}</p>
                    </div>
                </div>
                <div class="col">
                    <div class="flex">
                        <strong>Loc.:</strong>
                        <p>{{ servico.Localizador }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="servico.PoliticaCancelamento != '' || servico.PoliticaCancelamento != null">
        <details>
            <!-- <summary><strong>{{'Política de Cancelamento' | translate}}</strong></summary>
                                    <p class="text-justify" [innerHTML]="servico.PoliticaCancelamento"></p> -->
            <summary><strong>{{"Política de Cancelamento" | translate}}</strong></summary>
            <p class="text-justify">{{"Cancelamento: Cancelamento sem multa em até 72h da realização do serviço" |
                translate}}.</p>
        </details>
    </div>
    <div class="row">
        <details>
            <summary><strong>{{'Observações' | translate}}</strong></summary>
            <p class="text-justify" [innerHTML]="servico.Descricao"></p>
        </details>
    </div>
    <div class="row">
        <details>
            <summary><strong>{{'Perguntas' | translate}}</strong></summary>
            <div class="mt-4 row" *ngIf="servico.Perguntas && servico.Perguntas.length > 0">
                <div class="col col-md-3" *ngFor="let pergunta of servico.Perguntas">
                    <h6>{{pergunta.Pergunta}}</h6>
                    <p>R: {{pergunta.Resposta}}</p>
                </div>
            </div>
        </details>
    </div>
    <div class="row" *ngIf="servico.Fornecedor === 'CVT' && servico.ExtraIntegracao2 != null ">
        <details class="col-12 container">
            <summary><strong>{{"Tarifação" | translate}}</strong></summary>
            <div class="py-3 border">
                <div class="row px-3">
                    <div class="col-4">
                        <h5>{{"Tipo: "}}<span class="text-muted">
                                {{servico.ExtraIntegracao2?.Ingresso?.Nome}}
                            </span></h5>
                    </div>
                    <div class="col-5">
                        <h5>
                            {{"Data e Hora: "}}
                            <span class="text-muted">
                                {{servico.ExtraIntegracao2?.Data | date : 'dd/MM/yyyy'}} -
                                {{servico.ExtraIntegracao2?.Horario.length > 0
                                ? ((servico.ExtraIntegracao2?.Data + " " + servico.ExtraIntegracao2?.Horario) | date :
                                'HH:mm')
                                : ("Qualquer horário" | translate)
                                }}
                            </span>
                        </h5>
                    </div>
                    <div class="col-3">
                        <h5>{{"Valor Total: "}}<span class="text-muted">
                                {{servico.MoedaListagem?.Sigla}} {{servico.ValorListagem | currency:'BRL':'':'2.2-2'}}
                            </span></h5>
                    </div>
                    <div class="col-12 d-flex border justify-content-around align-items-center mt-4 p-4"
                        *ngFor="let categoriaIngresso of servico.ExtraIntegracao2.Ingresso?.Categorias">
                        <div class="col-5">
                            <h6>{{"Categoria" | translate}}: <span class="text-muted">{{categoriaIngresso.Nome}}</span>
                            </h6>
                        </div>
                        <div class="col-3">
                            <h6>{{"Quantidade" | translate}}: <span
                                    class="text-muted">{{categoriaIngresso.Quantidade}}</span></h6>
                        </div>
                        <div class="col">
                            <h6>
                                {{"Valor" | translate}}(UN):
                                <span class="text-muted">
                                    {{categoriaIngresso.PrecoListagem > 0 ?
                                    (servico.MoedaListagem?.Sigla + (categoriaIngresso.PrecoListagem |
                                    currency:'BRL':'':'2.2-2')) :
                                    ("Gratuito" | translate)}}
                                </span>
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
        </details>
    </div>
    <div class="row">
        <div class="col text-end">
            <strong>{{"Total" | translate}}: </strong>
            <strong class="price">{{servico.MoedaListagem?.Simbolo}} {{ servico.ValorListagem |
                currency:'BRL':'':'2.2-2'}}</strong>
        </div>
    </div>
    <div class="row mb-5">
        <div class="col">
            <p>{{"Adicionado em" | translate}}: {{ servico.Alteracoes.CriadoEm | date:'dd/MM/yyyy'}}
            </p>
        </div>
        <div class="col text-end" id="buttons" *ngIf="!cardSimplificado">
            <button class="btn btn-outline-danger" *ngIf="servico.Status == 0 || servico.Status == 8"
                (click)="removerServico(servico)">{{ "Excluir" | translate }}</button>

            <button *ngIf="([3,4].includes(servico.Status) && statusOrcamento != 6)" class="btn btn-outline-danger"
                (click)="modalCancela.open()">{{"Cancelar" | translate }}</button>

            <button *ngIf="servico.Status == 0" type="button" class="btn btn-success"
                (click)="validaSePodeReservar()">Reservar</button>

            <button *ngIf="(servico.Status == 3 || servico.Status == 4) && statusOrcamento ==6" type="button"
                class="btn btn-success" (click)="imprimirVoucherEmitter.emit(servico)" [disabled]="!liberarVouhcer">
                <span *ngIf="!liberarVouhcer" class="fas fa-exclamation-circle"></span>
                <span *ngIf="liberarVouhcer" class="fas fa-check-circle"></span>
                {{liberarVouhcer ? 'Voucher' : 'Voucher Pendente'}}
            </button>
        </div>
    </div>
</ng-container>

<!-- Template para o modal de reserva de serviço -->
<ng-template #tplReservaServico>
    <app-servico-reserva [servico]="servico"
        [orcamento]="{ Aereos: quantidadeItens.Aereos, Hoteis: quantidadeItens.Hoteis }"
        (alterou)="carregarObjetoEmitter.emit(servico.ReservaId)" (fechou)="modalReserva.close()">
    </app-servico-reserva>
</ng-template>

<!-- Template para o modal de cancelamento de serviço -->
<ng-template #tplCancelaServico>
    <app-servico-cancela [servico]="servico" (alterou)="carregarObjetoEmitter.emit(servico.ReservaId)"
        (fechou)="modalCancela.close()">
    </app-servico-cancela>
</ng-template>

<!-- Modais utilizando os templates -->
<app-modal #modalReserva
    [modalConfig]="{ modalTitle: 'Reservar Serviço', hideCloseButton: true, hideDismissButton: true }"
    [template]="tplReservaServico">
</app-modal>

<app-modal #modalCancela
    [modalConfig]="{ modalTitle: 'Cancelar Serviço', hideCloseButton: true, hideDismissButton: true }"
    [template]="tplCancelaServico">
</app-modal>